module.exports = __webpack_public_path__ + "img/banner-sustainable-cities-and-communities.47f18836.png";